export default ({ request }) => ({
  masterFabricEcomList(data = {}) {
    return request({
      url: '/digitalCenter/masterFabric/ecomList',
      method: 'post',
      data,
    })
  },
  masterFabricSeriesList(data = {}) {
    return request({
      url: '/digitalCenter/masterFabric/seriesList',
      method: 'post',
      data,
    })
  },
  masterFabric_detail(data = {}) {
    return request({
      url: '/digitalCenter/masterFabric/detail',
      method: 'post',
      data,
    })
  },
  masterFabricEcomSave(data = {}) {
    return request({
      url: '/digitalCenter/masterFabric/ecomSave',
      method: 'post',
      data,
    })
  },
  masterFabricEcomDel(data = {}) {
    return request({
      url: '/digitalCenter/masterFabric/ecomDel',
      method: 'post',
      data,
    })
  },
  masterFabricSubmit(data = {}) {
    return request({
      url: '/digitalCenter/masterFabric/submit',
      method: 'post',
      data,
    })
  },
  masterFabricReview(data = {}) {
    return request({
      url: '/digitalCenter/masterFabric/review',
      method: 'post',
      data,
    })
  },
  masterFabricEcomRecovery(data = {}) {
    return request({
      url: '/digitalCenter/masterFabric/ecomRecovery',
      method: 'post',
      data,
    })
  },
  masterAttributeDictionary_list(data = {}) {
    return request({
      url: '/digitalCenter/masterAttributeDictionary/list',
      method: 'post',
      data,
    })
  },
  masterFabricChooseListApi(data = {}) {
    return request({
      url: '/digitalCenter/masterFabric/choose',
      method: 'post',
      data,
    })
  },
  masterFabricImageListApi(data = {}) {
    return request({
      url: '/digitalCenter/master/fabric/image/list',
      method: 'post',
      data,
    })
  },
  masterFabricImageBatchUploadApi(data = {}) {
    return request({
      url: '/digitalCenter/master/fabric/image/batch/upload',
      method: 'post',
      data,
      timeout: 60000,
    })
  },
  masterFabricImageUploadApi(data = {}) {
    return request({
      url: '/digitalCenter/master/fabric/image/upload',
      method: 'post',
      data,
      timeout: 60000,
    })
  },
  masterFabricImageDelApi(data = {}) {
    return request({
      url: '/digitalCenter/master/fabric/image/del',
      method: 'post',
      data,
    })
  },
  masterFabricImageSetDefaultApi(data = {}) {
    return request({
      url: '/digitalCenter/master/fabric/image/setDefault',
      method: 'post',
      data,
    })
  },
  masterFabricImageUpdateSortOrderApi(data = {}) {
    return request({
      url: '/digitalCenter/master/fabric/image/updateSortOrder',
      method: 'post',
      data,
    })
  },
  masterFabricColor_ListApi(data = {}) {
    return request({
      url: '/digitalCenter/master/fabric/color/list',
      method: 'post',
      data,
    })
  },
  masterFabricColor_DetailApi(data = {}) {
    return request({
      url: '/digitalCenter/master/fabric/color/detail',
      method: 'post',
      data,
    })
  },
  masterFabricColor_SaveApi(data = {}) {
    return request({
      url: '/digitalCenter/master/fabric/color/save',
      method: 'post',
      data,
    })
  },
  masterFabricColor_DelApi(data = {}) {
    return request({
      url: '/digitalCenter/master/fabric/color/del',
      method: 'post',
      data,
    })
  },
  masterFabricColorChoooseApi(data = {}) {
    return request({
      url: '/digitalCenter/master/fabric/color/choose',
      method: 'post',
      data,
    })
  },
})
